/**************************************************
 * Nombre:       Valores_Reservas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {PriceCheckOutlined} from "@mui/icons-material";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useEffect, useState} from "react";
import {obtenerValorSaldo} from "../../CodNegocio/obtenerValorSaldo";

const Valores_Reservas = ({props}) => {
    const [valAdicionales, setValAdicionales] = useState(0)
    const [valDescuentos, setValDescuentos] = useState(0)

    const Linea = ({titulo, valor, descuento = false, texto=false}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}} sx={{px: 1}}>

                <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{mt: -1}}>
                    <Typography>{titulo}</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-end', mt: -1}}>
                    {texto ?

                        <Typography
                            sx={{fontWeight: 600}}>{valor}
                        </Typography>

                        :

                        <Typography
                            sx={{fontWeight: 600}}>{descuento ? `-${formatoMoneda(valor)}` : `${formatoMoneda(valor)}`}
                        </Typography>

                    }

                </Grid>


            </Grid>
        )
    }

    const valorTotal = (arr) => {

        let val = 0
        for (let i = 0; i < arr.length; i++) {
            val += arr[i].valor
        }

        return val
    }


    useEffect(() => {

        let adicionales = props.props.getValues('adicionales')
        let descuentos = props.props.getValues('descuentos')

        if (adicionales) {
            let totAdi = valorTotal(adicionales)
            setValAdicionales(totAdi)
        }

        if (descuentos) {
            let totDes = valorTotal(descuentos)
            setValDescuentos(totDes)
        }


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Linea titulo={`Numero de Noches: `}
                   valor={props.props.getValues('numNoches')} texto={true}/>


            <Linea titulo={`Valor Adultos ( ${props.props.getValues('numAcompanantes')} )`}
                   valor={props.props.getValues('valorAdultos')}/>

            <Linea titulo={`Valor Niños ( ${props.props.getValues('numNinos')} ):`}
                   valor={props.props.getValues('valorNinos')}/>

            <Linea titulo={'Total Adicionales:'} valor={valAdicionales}/>

            <Linea titulo={'Total Descuentos:'} valor={valDescuentos} descuento={true}/>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{borderTop: 1, pt: 3}} >
                <Linea titulo={'Saldo:'}
                       valor={obtenerValorSaldo(
                           {
                               adicionales:props.props.getValues('adicionales'),
                               descuentos:props.props.getValues('descuentos'),
                               totalReserva: props.props.getValues('valor'),
                               abonos: props.props.getValues('abonos')
                           }
                       )}/>
            </Grid>


        </Grid>
    )

}
export default Valores_Reservas